export const environment = {
    BUILD_PRODUCT: "user-app",
    ESTIMATED_DELIVERY_FEE_CENTS: 600,
    API_URL_BASE: "https://api.12082026.xyz/",
    PRODUCT_URLS: {
        LANDING_PAGE: "https://12082026.xyz",
        USER_APP: "https://app.12082026.xyz",
        RESTAURANT: "https://restaurant.12082026.xyz",
        DRIVER: "https://driver.12082026.xyz",
        ADMIN: "https://admin.12082026.xyz",
        ACCOUNT: "https://account.12082026.xyz",
        ACCOUNT_REGISTRATION: "https://account.12082026.xyz/register",
        ACCOUNT_RESET_PASSWORD: "https://account.12082026.xyz/forgot-password"
    },
    STRIPE_PUBLISHABLE_KEY: "pk_test_51PdTiERrbKJHrpRQ8aEqhK0vQJT9Z7a8cbzzQ6g7fapFnMnwJdzz5HuCwYPFanl4AqjN2I44GxBXJGAByLPxcTgv00Jrbc9E26",
    API_USER_SELF: "v1/users/self",
    API_USER_ADDRESSES: "v1/users/self/addresses",
    API_USER_SET_DEFAULT_ADDRESS: "v1/users/self/addresses/{{address_id}}/default",
    API_USER_UPDATE_DELETE_ADDRESS: "v1/users/self/addresses/{{address_id}}",
    API_GET_RESTAURANTS_LIST: "v1/restaurants/search",
    API_GET_FULL_RESTAURANT: "v1/public/restaurants/{{restaurantId}}",
    API_GET_FULL_RESTAURANT_BY_SLUG: "v1/public/restaurants/slug/{{slug}}",
    API_ORDERS: "v1/users/orders",
    API_INDIVIDUAL_ORDER: "v1/users/orders/{{order_id}}",
    API_STRIPE_PAYMENT_INTENT: "v1/users/orders/{{order_id}}/payment-intent",
    API_ORDER_REVIEW_POST: "v1/users/orders/{{orderId}}/review",
    DEBUG_STAGING_BADGE: true
};
